import React, { useEffect, useRef } from 'react';
import welcomeAudio from '../../media/Welcome Allhome_voice.mp3';

export default function FirstQualifiedAppCelebration({ applicantName, onDone }) {
    const audioRef = useRef(null);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = 1;
            audioRef.current.play().catch(() => {});
        }

        function handleMessage(e) {
            if (e.data === 'close-celebration') {
                onDone && onDone();
            }
        }
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [onDone]);

    const src = `/leaderBoard/breadwinners-first-app.html?name=${encodeURIComponent(applicantName || 'Our New Member')}&chrome=0`;

    return (
        <>
            <audio ref={audioRef} src={welcomeAudio} onEnded={onDone} />
            <iframe
                src={src}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    zIndex: 99999,
                }}
                title="First Qualified App Celebration"
                allow="autoplay"
            />
        </>
    );
}
